export enum EDITOR_TOOLBAR_TYPE {
    block = 'block',
    selection = 'selection',
}
